import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

//types
import type { ErrorCustom } from '@/utils/client';
//utils
import { get } from '@/utils/client';

//apiEndpoint
import { USER_PUBLIC_TOKENS } from '@/routes/apiEndpoints';

export type UserPublicTokenType = {
    id: number;
    name: string;
    created_at: string;
    last_use: string;
    expires_at: string;
};

type useUserPublicTokensType = {
    options?: SWRConfiguration<UserPublicTokenType[], ErrorCustom>;
};
const useUserPublicTokens = ({ options }: useUserPublicTokensType = {}) => {
    const {
        data: userPublicTokens,
        mutate: mutateUserPublicTokens,
        error: userPublicTokensError,
        isLoading
    } = useSWR<UserPublicTokenType[], ErrorCustom>(
        USER_PUBLIC_TOKENS,
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            ...options
        }
    );

    return {
        userPublicTokens,
        mutateUserPublicTokens,
        userPublicTokensError,
        isLoading
    };
};
export default useUserPublicTokens;
